import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=25c73c84&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"
import style0 from "./contact.vue?vue&type=style&index=0&id=25c73c84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c73c84",
  null
  
)

export default component.exports